import "core-js/modules/es.string.small.js";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import { ShadowContainer, Typography, Grid, RaiseColors, makeStyles, useTheme, InfoIconPopper, Divider, RaiseBadge, BadgeSizeEnum, BadgeTypeEnum, BadgeVariantEnum } from "componentLibrary";
import useWindowSize from "hooks/useWindowSize";
import { useDeviceDetection } from "hooks/useDeviceDetection";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var ResponsiveOverViewTable = function ResponsiveOverViewTable(_ref) {
  var _useWindowSize$innerW;
  var dataList = _ref.dataList;
  var theme = useTheme();
  var windowSize = (_useWindowSize$innerW = useWindowSize().innerWidth) !== null && _useWindowSize$innerW !== void 0 ? _useWindowSize$innerW : 0;
  var padding = "16px";
  var mobileSize = false;
  if (windowSize >= _valuesInstanceProperty(theme.breakpoints).laptop) {
    padding = "24px";
    return /*#__PURE__*/_jsx(ShadowContainer, {
      style: {
        padding: padding,
        minWidth: "900px"
      },
      children: /*#__PURE__*/_jsx(ResponsiveOverViewTableDesktop, {
        dataList: dataList
      })
    });
  }
  if (windowSize <= _valuesInstanceProperty(theme.breakpoints).lg) {
    mobileSize = true;
  }
  return /*#__PURE__*/_jsx(ShadowContainer, {
    style: {
      padding: padding
    },
    children: /*#__PURE__*/_jsx(ResponsiveOverViewTableTabletMobile, {
      dataList: dataList,
      mobileSize: mobileSize
    })
  });
};
export default ResponsiveOverViewTable;
var desktopStyles = makeStyles(function (theme) {
  return {
    firstInRow: {
      paddingRight: "24px",
      borderRight: "1px solid ".concat(RaiseColors.neutral300)
    },
    middleInRow: {
      paddingRight: "24px",
      paddingLeft: "24px",
      borderRight: "1px solid ".concat(RaiseColors.neutral300)
    },
    lastInRow: {
      paddingLeft: "24px"
    },
    emptyStyleState: {},
    bodyContainer: {
      alignItems: "center",
      display: "flex"
    }
  };
});
export var ResponsiveOverViewTableDesktop = function ResponsiveOverViewTableDesktop(_ref2) {
  var dataList = _ref2.dataList;
  var classes = desktopStyles();
  var gridSplit = 0;
  var multiLine = (dataList === null || dataList === void 0 ? void 0 : dataList.length) > 4;
  if (multiLine) {
    gridSplit = Math.floor(12 / ((dataList === null || dataList === void 0 ? void 0 : dataList.length) / 2));
  } else {
    gridSplit = Math.floor(12 / (dataList === null || dataList === void 0 ? void 0 : dataList.length));
  }
  var GridCellStyleCalculator = function GridCellStyleCalculator(index, arr) {
    var firstInRow = false;
    var middleInRow = false;
    var lastInRow = false;
    var gridCellStyle = classes.emptyStyleState;
    firstInRow = index === 0;
    lastInRow = index === arr.length - 1;
    middleInRow = !firstInRow && !lastInRow;
    if (firstInRow) {
      gridCellStyle = classes.firstInRow;
    } else if (middleInRow) {
      gridCellStyle = classes.middleInRow;
    } else {
      gridCellStyle = classes.lastInRow;
    }
    return gridCellStyle;
  };
  if (multiLine) {
    var middleIndex = Math.ceil(dataList.length / 2);
    var firstHalf = _sliceInstanceProperty(dataList).call(dataList, 0, middleIndex);
    var secondHalf = _sliceInstanceProperty(dataList).call(dataList, middleIndex);
    return /*#__PURE__*/_jsxs(Grid, {
      container: true,
      children: [_mapInstanceProperty(firstHalf).call(firstHalf, function (item, index, arr) {
        var _item$pillType, _item$pillVariant;
        var gridCellStyle = GridCellStyleCalculator(index, arr);
        return /*#__PURE__*/_jsx(Grid, {
          item: true,
          xs: gridSplit,
          children: /*#__PURE__*/_jsxs("div", {
            className: gridCellStyle,
            children: [/*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(Typography, {
                weight: "semibold",
                variant: "paragraph_xsmall",
                color: RaiseColors.neutral500,
                style: {
                  paddingBottom: "8px"
                },
                children: item.title
              })
            }), /*#__PURE__*/_jsx("div", {
              className: classes.bodyContainer,
              children: /*#__PURE__*/_jsxs(_Fragment, {
                children: [item.body, item !== null && item !== void 0 && item.pillText ? /*#__PURE__*/_jsx("div", {
                  style: {
                    marginLeft: "12px"
                  },
                  children: /*#__PURE__*/_jsx(RaiseBadge, {
                    size: BadgeSizeEnum.small,
                    type: (_item$pillType = item.pillType) !== null && _item$pillType !== void 0 ? _item$pillType : BadgeTypeEnum.destructive,
                    variant: (_item$pillVariant = item.pillVariant) !== null && _item$pillVariant !== void 0 ? _item$pillVariant : BadgeVariantEnum.outlined,
                    children: item.pillText
                  })
                }) : null]
              })
            })]
          })
        }, index);
      }), _mapInstanceProperty(firstHalf).call(firstHalf, function (item, index, arr) {
        var padding = "";
        if (index === 0) {
          padding = "16px 24px 16px 0px";
        } else if (index === arr.length - 1) {
          padding = "16px 0px 16px 24px";
        } else {
          padding = "16px 24px";
        }
        return /*#__PURE__*/_jsx(Grid, {
          item: true,
          xs: gridSplit,
          style: {
            padding: padding
          },
          children: /*#__PURE__*/_jsx("div", {
            style: {
              borderBottom: "1px solid ".concat(RaiseColors.neutral300)
            }
          })
        }, index);
      }), _mapInstanceProperty(secondHalf).call(secondHalf, function (item, index, arr) {
        var _item$pillType2, _item$pillVariant2;
        var gridCellStyle = GridCellStyleCalculator(index, arr);
        return /*#__PURE__*/_jsx(Grid, {
          item: true,
          xs: gridSplit,
          children: /*#__PURE__*/_jsxs("div", {
            className: gridCellStyle,
            children: [/*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(Typography, {
                weight: "semibold",
                variant: "paragraph_xsmall",
                color: RaiseColors.neutral500,
                style: {
                  paddingBottom: "8px"
                },
                children: item.title
              })
            }), /*#__PURE__*/_jsx("div", {
              className: classes.bodyContainer,
              children: /*#__PURE__*/_jsxs(_Fragment, {
                children: [item.body, item !== null && item !== void 0 && item.pillText ? /*#__PURE__*/_jsx("div", {
                  style: {
                    marginLeft: "12px"
                  },
                  children: /*#__PURE__*/_jsx(RaiseBadge, {
                    size: BadgeSizeEnum.small,
                    type: (_item$pillType2 = item.pillType) !== null && _item$pillType2 !== void 0 ? _item$pillType2 : BadgeTypeEnum.destructive,
                    variant: (_item$pillVariant2 = item.pillVariant) !== null && _item$pillVariant2 !== void 0 ? _item$pillVariant2 : BadgeVariantEnum.outlined,
                    children: item.pillText
                  })
                }) : null]
              })
            })]
          })
        }, index);
      })]
    });
  }
  return /*#__PURE__*/_jsx(Grid, {
    container: true,
    children: _mapInstanceProperty(dataList).call(dataList, function (item, index, arr) {
      var _item$pillType3, _item$pillVariant3;
      var gridCellStyle = GridCellStyleCalculator(index, arr);
      return /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: gridSplit,
        children: /*#__PURE__*/_jsxs("div", {
          className: gridCellStyle,
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Typography, {
              weight: "semibold",
              variant: "paragraph_xsmall",
              color: RaiseColors.neutral500,
              style: {
                paddingBottom: "8px"
              },
              children: item.title
            })
          }), /*#__PURE__*/_jsx("div", {
            className: classes.bodyContainer,
            children: /*#__PURE__*/_jsxs(_Fragment, {
              children: [item.body, item !== null && item !== void 0 && item.pillText ? /*#__PURE__*/_jsx("div", {
                style: {
                  marginLeft: "12px"
                },
                children: /*#__PURE__*/_jsx(RaiseBadge, {
                  size: BadgeSizeEnum.small,
                  type: (_item$pillType3 = item.pillType) !== null && _item$pillType3 !== void 0 ? _item$pillType3 : BadgeTypeEnum.destructive,
                  variant: (_item$pillVariant3 = item.pillVariant) !== null && _item$pillVariant3 !== void 0 ? _item$pillVariant3 : BadgeVariantEnum.outlined,
                  children: item.pillText
                })
              }) : null]
            })
          })]
        })
      }, index);
    })
  });
};
var mobileStyles = makeStyles(function (theme) {
  return {
    bodyContainer: {
      alignItems: "center",
      display: "flex",
      paddingBottom: "8px"
    }
  };
});
export var ResponsiveOverViewTableTabletMobile = function ResponsiveOverViewTableTabletMobile(_ref3) {
  var dataList = _ref3.dataList,
    mobileSize = _ref3.mobileSize,
    hasNoData = _ref3.hasNoData;
  var classes = mobileStyles();
  var device = useDeviceDetection();
  return /*#__PURE__*/_jsx(Grid, {
    container: true,
    spacing: 3,
    justifyContent: "space-between",
    children: _mapInstanceProperty(dataList).call(dataList, function (item, index, arr) {
      var _item$pillType4, _item$pillVariant4;
      return /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: mobileSize ? 12 : 6,
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("div", {
            className: classes.bodyContainer,
            children: [/*#__PURE__*/_jsx(Typography, {
              weight: "semibold",
              variant: "paragraph_xsmall",
              color: hasNoData ? RaiseColors.neutral400 : RaiseColors.neutral500,
              children: item.title
            }), item !== null && item !== void 0 && item.pillText ? /*#__PURE__*/_jsx("div", {
              style: {
                marginLeft: "12px"
              },
              children: /*#__PURE__*/_jsx(RaiseBadge, {
                size: BadgeSizeEnum.small,
                type: (_item$pillType4 = item.pillType) !== null && _item$pillType4 !== void 0 ? _item$pillType4 : BadgeTypeEnum.destructive,
                variant: (_item$pillVariant4 = item.pillVariant) !== null && _item$pillVariant4 !== void 0 ? _item$pillVariant4 : BadgeVariantEnum.outlined,
                children: item.pillText
              })
            }) : null, item.infoText && /*#__PURE__*/_jsx(InfoIconPopper, {
              title: item.title,
              infoText: item.infoText,
              popperPlacement: "bottom",
              style: {
                marginLeft: "8px"
              },
              useMobile: device.isMobile
            }), item.actions && item.actions]
          }), /*#__PURE__*/_jsx("div", {
            children: item.body
          })]
        })
      }, index);
    })
  });
};
var pillStyles = makeStyles(function (theme) {
  return {
    bodyContainer: {
      alignItems: "center",
      display: "flex",
      paddingBottom: "8px"
    },
    pillTextRed: {
      backgroundColor: "rgba(239, 68, 68, 0.16)"
    },
    pillTextGreen: {
      backgroundColor: RaiseColors.success100
    }
  };
});
var Pill = function Pill(_ref4) {
  var variant = _ref4.variant,
    text = _ref4.text;
  var classes = pillStyles();
  var pillTextStyles = {
    "class": "",
    color: ""
  };
  if (variant === "red") {
    pillTextStyles["class"] = classes.pillTextRed;
    pillTextStyles.color = RaiseColors.destructive700;
  } else if (variant === "green") {
    pillTextStyles["class"] = classes.pillTextGreen;
    pillTextStyles.color = RaiseColors.success700;
  }
  return /*#__PURE__*/_jsx(Typography, {
    style: {
      borderRadius: "200px",
      padding: "4px 16px 4px 16px"
    },
    color: pillTextStyles.color,
    weight: "semibold",
    variant: "paragraph_xsmall",
    className: pillTextStyles["class"],
    children: text
  });
};
export { Pill };
// Resizes the content of each grid based on the content of the element. The remaining white space is distributed evenly.
export var HorizontalResponsiveOverviewForItemContent = function HorizontalResponsiveOverviewForItemContent(_ref5) {
  var dataList = _ref5.dataList,
    hasNoData = _ref5.hasNoData;
  var device = useDeviceDetection();
  return /*#__PURE__*/_jsx("div", {
    style: {
      display: "flex",
      flexDirection: "row"
    },
    children: _mapInstanceProperty(dataList).call(dataList, function (item, index) {
      var isLastElement = dataList.length - 1 === index;
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            display: "flex",
            flexGrow: 1
          },
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column"
            },
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline"
              },
              children: [/*#__PURE__*/_jsx(Typography, {
                variant: "paragraph_xsmall",
                weight: "semibold",
                color: hasNoData ? RaiseColors.neutral400 : RaiseColors.neutral500,
                style: {
                  marginBottom: "8px"
                },
                children: item.title
              }), item.infoText && /*#__PURE__*/_jsx(InfoIconPopper, {
                title: item.title,
                infoText: item.infoText,
                popperPlacement: "bottom",
                style: {
                  marginLeft: "8px"
                },
                useMobile: device.isMobile
              }), item.actions && item.actions]
            }), item.body]
          })
        }), !isLastElement && /*#__PURE__*/_jsx("div", {
          style: {
            display: "flex"
          },
          children: /*#__PURE__*/_jsx(Divider, {
            color: RaiseColors.neutral500,
            style: {
              margin: "0px 12px"
            },
            orientation: "vertical"
          })
        })]
      }, index);
    })
  });
};